import React from 'react';
import DashboardTable from '../DashboardTable/dashboard-table';

interface MerckTMDashboardProps {
    accessRole?: string; // Optional prop to pass the user role
}

const MerckTMDashboard: React.FC<MerckTMDashboardProps> = ({ accessRole }) => {
    return (
        <div>
            <DashboardTable accessRole={accessRole} />
        </div>

    );
};

export default MerckTMDashboard;
